import { Brick, registerBrick, BrickContext, Predicate, Query } from 'olympe';
import { getLogger } from '@olympeio/core';
import BCP from './DM_BCP';
import {isBCPTerminated} from '../../web/section_risk/RiskCrisis';

/**
 * Combinations that has already been checked and are an ongoing requests
 */
const checkedCombinations = new Set();

export default class IsCombinationsUnique extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string | Object} selectedObjects
     * @param {*} selectedObject
     * @param {function()} forwardEvent
     * @param {function(boolean)} setIsUnique
     * @param {function(string | null)} setDuplicated
     */
    async update($, [selectedObjects, selectedObject], [forwardEvent, setIsUnique, setDuplicated]) {
        try {
            const objects = typeof selectedObjects === 'string' ? JSON.parse(selectedObjects) : selectedObjects;
            let isUnique = true;
            let duplicated = null;

            console.log("selectedObject", selectedObject);
            console.log("selectedObject.reasonCode", selectedObject.reasonCode);

            // Check if selection contains items that previously checked and are existing requests
            const alreadyChecked = (array) => array.some(element => checkedCombinations.has(element.id));
            const isBCPRequestTerminated = await isBCPTerminated(selectedObject, $);
            const isBCPRDApplicable = selectedObject.reasonCode == "BCP Request R&D";
            if ((!isBCPRequestTerminated && alreadyChecked(objects)) || isBCPRDApplicable) {
                isUnique = false;
                duplicated = selectedObject;
            }
            // Check if recently added item is an existing request
            else if (!isBCPRequestTerminated && selectedObject !== null) {
                const queryResult = await Query.instancesOf(BCP).filter(Predicate.and(
                    Predicate.equals(BCP.materialIdProp, selectedObject.materialId),
                    Predicate.equals(BCP.plantIdProp, selectedObject.plantId)
                )).execute();

                // No such instance found
                isUnique = queryResult.getFirst() === null;

                // Save to cache
                if (!isUnique) {
                    checkedCombinations.add(selectedObject.id);
                }
            }

            // Done
            setIsUnique(isUnique);
            setDuplicated(duplicated);
            forwardEvent();
        }
        // Error while parsing JSON or running query
        catch (error) {
            getLogger('IsCombinationsUnique').error(error);
        }
    }
}

registerBrick('0188532bd4ce5467af51', IsCombinationsUnique);
